import { render, staticRenderFns } from "./AssetsMap.vue?vue&type=template&id=12d330a0&scoped=true&"
import script from "./AssetsMap.vue?vue&type=script&lang=js&"
export * from "./AssetsMap.vue?vue&type=script&lang=js&"
import style0 from "./AssetsMap.vue?vue&type=style&index=0&id=12d330a0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12d330a0",
  null
  
)

export default component.exports